import React from "react";
import { LongTextLabel, Tooltip, ValueOrPlaceholder } from "@sscs/ui";
import { getExtension } from "Utils";
import styles from "./fileTypeIcon.module.scss";

type FileTypeIconProps = { fileName: string; architecture: string };

const FileTypeIcon = ({
  fileName,
  architecture,
}: FileTypeIconProps): React.JSX.Element => {
  const extension = getExtension(fileName);

  return (
    <Tooltip
      title="No file extension"
      trigger="graphic"
      disabled={extension !== null}
    >
      <div className={styles["file-type-icon"]}>
        {extension === null ? (
          <div className={styles["extension-missing"]}>
            <ValueOrPlaceholder value={extension} />
          </div>
        ) : (
          <div className={styles.extension}>
            <LongTextLabel label={extension} />
          </div>
        )}
        <div className={styles.architecture}>{architecture}</div>
      </div>
    </Tooltip>
  );
};

export default FileTypeIcon;
